"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Facebook` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Facebook = createSVGIcon(
  <path
    d="M13.766 6.886c0-1.776.806-1.776 1.61-1.776h1.028a1.303 1.303 0 0 0 1.305-1.303V2.228A1.3 1.3 0 0 0 16.435.934C15.466.92 14.45.891 14.002.891a4.91 4.91 0 0 0-5.058 5.495v2.478H7.586a1.3 1.3 0 0 0-1.301 1.303v1.615a1.303 1.303 0 0 0 1.3 1.303h1.359v9.166a.857.857 0 0 0 .857.857h3.108a.857.857 0 0 0 .857-.857v-9.166h1.502a1.303 1.303 0 0 0 1.302-1.303v-1.615a1.303 1.303 0 0 0-1.303-1.303h-1.501z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Facebook",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "UsBSnl",
      defaultMessage: "Facebook",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  })
);
